<template>
  <form class="vl-form" @submit.prevent="onSubmit">
    <vl-grid v-vl-spacer:bottom.medium>
      <vl-column width="12" width-s="12" width-xs="12">
        <vl-properties-list v-if="data.specification">
          <vl-properties-label>{{ $t('productspecification.detail.id') }}</vl-properties-label>
          <vl-properties-data>{{ data.specification.id }}</vl-properties-data>
          <vl-properties-label>{{ $t('productspecification.detail.label') }}</vl-properties-label>
          <vl-properties-data>{{ data.specification.label }}</vl-properties-data>
        </vl-properties-list>
      </vl-column>
      <vl-column width="12" width-s="12" width-xs="12">
        <vl-action-group v-vl-spacer:top.medium>
          <vl-button :mod-disabled="data.isSaving" :mod-loading="data.isSaving">{{
            $t('productspecification.actions.generateFeatureCatalog.download')
          }}</vl-button>
          <vl-button :to="featureCatalogXmlUrl" mod-secondary @click.prevent="showXml">
            {{ $t('productspecification.actions.generateFeatureCatalog.viewXml') }}
          </vl-button>
          <vl-button :mod-disabled="data.isSaving" mod-icon-before mod-secondary tag-name="a" @click.prevent="cancel">
            {{ $t('general.cancel') }}
          </vl-button>
        </vl-action-group>
      </vl-column>
    </vl-grid>
  </form>
</template>
<script lang="ts" setup>
import 'vue-i18n';
import { useForm } from 'vee-validate';
import { computed, onMounted, reactive } from 'vue';
import { useModalStore } from '@/modules/core/store/modal.store';
import { useProductSpecificationStore } from '@/modules/configuration/store/product-specification/product-specification.store';
import { object } from 'yup';

const store = useProductSpecificationStore();

const props = defineProps({
  id: {
    type: Number,
    required: true
  },
  definitionId: {
    type: Number,
    required: true
  }
});

const data = reactive({
  specification: null,
  isSaving: false
});

const validationSchema = object({});

const { handleSubmit, resetForm } = useForm({
  validationSchema
});

const detail = computed(() => {
  const specs = store.byDefinition(props.definitionId);
  return specs?.find((spec) => spec.id === props.id);
});

const showXml = () => {
  window.open(featureCatalogXmlUrl.value, '_blank');
};

const featureCatalogXmlUrl = computed(() => {
  return `/backoffice/api/v1/productspecification/${props.id}/feature-catalog`;
});

onMounted(async () => {
  resetForm({
    values: {}
  });

  const specs = store.byDefinition(props.definitionId);
  const specification = specs?.find((spec) => spec.id === props.id);
  if (specification) {
    data.specification = specification;
  }
});

const cancel = () => {
  closeModal();
};

const closeModal = () => {
  useModalStore().hideModal();
};

const onSuccess = async () => {
  data.isSaving = true;
  await store.generateFeatureCatalog(props.id, {
    // TODO options
  });
  data.isSaving = false;

  closeModal();
};

const onInvalidSubmit = ({ values, errors, results }) => {
  // console.log(values); // current form values
  // console.log(errors); // a map of field names and their first error message
  // console.log(results); // a detailed map of field names and their validation results
};

const onSubmit = handleSubmit(onSuccess, onInvalidSubmit);
</script>
<style lang="scss" scoped></style>
